




































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import Popup from '@/components/Popups/Popup.vue';

@Component({
    components: {
        Popup
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class ConfirmationPopup extends Vue {
    // Member
    public visibility = false;

    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: false })
    public title?: string;

    @Prop({ required: false })
    public text?: string;

    @Prop({ required: false })
    public icon?: string;

    @Prop({ required: false, default: false, type: Boolean })
    public yes!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public no!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public cancel!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public ok!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public question!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public exclamation!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public error!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public warning!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public info!: boolean;


    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    // Lifecycle Methods:

    // Methods:
    public close(): void {
        this.visible = false;
    }

    public onYes(): void {
        this.$emit('yes');
        this.close();
    }

    public onNo(): void {
        this.$emit('no');
        this.close();
    }

    public onOk(): void {
        this.$emit('ok');
        this.close();
    }

    public onCancel(): void {
        this.$emit('cancel');
        this.close();
    }
}
